import { FelaCSS, colors, FelaCSSWithCustomSelectors } from '@bridebook/ui';

interface IStyleProps {
  isBenefits: boolean;
}

interface IStyles {
  wrapper: FelaCSS;
  questionsWrap: FelaCSS;
  faqItem: FelaCSSWithCustomSelectors;
  loaderWrap: FelaCSS;
  faqTitle: FelaCSS;
  faqDescription: FelaCSS;
  accordionWrapper: FelaCSS;
}

const styles = ({ isBenefits }: IStyleProps): IStyles => ({
  loaderWrap: {
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '32px',
  },

  wrapper: {
    paddingBottom: isBenefits ? '8px' : '32px',
  },

  questionsWrap: {
    flexDirection: 'row',
    flexWrap: 'wrap',
  },

  faqItem: {
    flexShrink: 0,
    width: '50%',
    paddingRight: '32px',

    maxWidthMobile: {
      width: '100%',
      paddingRight: '0',
    },

    ':nth-of-type(even)': {
      paddingLeft: '32px',
      paddingRight: '0',

      maxWidthMobile: {
        paddingLeft: '0',
      },
    },

    ':nth-of-type(n + 3)': {
      marginTop: '24px',
    },

    ':nth-of-type(n + 2)': {
      maxWidthMobile: {
        marginTop: '24px',
      },
    },

    '& ol': {
      display: 'block',
      marginTop: 0,
      paddingLeft: 10,
      marginBottom: 8,

      '& li': {
        listStyleType: 'decimal',
      },
    },

    '& ul': {
      listStyleType: 'disc',
      display: 'block',
      paddingLeft: 10,
      marginBottom: 8,

      '& li': {
        listStyleType: 'disc',
      },
    },

    '& b, & strong': {
      fontDefaultSemiBold: 'inherit',
    },
  },
  faqTitle: {
    fontDefaultSemiBold: 28,
    marginBottom: 2,
    maxWidthMobile: {
      fontDefaultSemiBold: 20,
    },
  },
  faqDescription: {
    fontDefault: 14,
  },
  accordionWrapper: {
    borderBottom: `1px solid ${colors.space15}`,
    paddingVertical: 5,
  },
});

export default styles;
